import { boot } from 'quasar/wrappers'

export default boot(async ({ store, redirect, urlPath }) => {
  const { piva } = store.state.tenant
  if (piva) {
    try {
      await store.dispatch('tenant/setApplications', piva)
    } catch {
      urlPath !== '/423' && redirect('/423')
    }
  }
})
